var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","text":"","depressed":""},on:{"click":_vm.voltar}},[_c('v-icon',[_vm._v("chevron_left")]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }